import { Action } from "redux";

export enum ListActionType {
    LIST_PAGE_INIT = "LIST_PAGE_INIT",
}

export interface IInitListDetailsAction extends Action {
    type: ListActionType.LIST_PAGE_INIT;
    payload: {
        listId: number;
    };
}

export const initListAction = (listId: number) => ({
    type: ListActionType.LIST_PAGE_INIT,
    payload: {
        listId,
    },
});

export type IListDetailsAction = IInitListDetailsAction;
